<template>
    <BaseDropdown>
        <template v-slot:activator>
            {{ title }}
        </template>
        <template v-slot:items>
            <slot></slot>
        </template>
    </BaseDropdown>
</template>

<script>
import BaseDropdown from "@/base/header/components/BaseDropdown";
export default {
    name: "Dropdown",
    components: {
        BaseDropdown
    },
    props: {
        title: {
            type: String,
            required: true,
            default: "No title"
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
